import React, { useState, useEffect } from "react"
import _ from "lodash"
import { useFormikContext, Field } from "formik"

import { Dropdown } from "primereact/dropdown"

import styles from "../../../../../styles/Form.module.css"
import goalsDef from "./resources/goals.json"

export default function DynamicGoal(props) {
  const [goalOptions, setGoalOptions] = useState([])

  const formik = useFormikContext()
  const currentMFValues = formik.values[props.mfFieldName][props.mfIndex]

  const { field, index, mfFieldName, mfIndex } = props
  const fieldSlug = `${mfFieldName}.${mfIndex}.${field.field_name}`

  const { domain } = currentMFValues

  useEffect(() => {
    const domainGoals = _.find(goalsDef, { domain })
    if (domainGoals) setGoalOptions(domainGoals.options)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domain])

  const isRequired = true

  return (
    <div
      className={styles.field}
      style={{
        order: index,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={fieldSlug}>
        {({ field: formikField, meta }) => (
          <>
            <Dropdown
              placeholder="Please select"
              id={field.field_name}
              name={formikField.name}
              value={formikField.value}
              // onChange={formikField.onChange}
              onChange={({ value }) => {
                formik.setFieldValue(formikField.name, value)
                // Reset 'action_activity' Fields
                const planGoalsList =
                  currentMFValues["recovery_plan_goals_actions"]
                _.forEach(planGoalsList, (goal, index) => {
                  const goalField = `${mfFieldName}.${mfIndex}.recovery_plan_goals_actions.${index}.action_activity`
                  formik.setFieldValue(goalField, "")
                })
              }}
              options={goalOptions}
            />
            {meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
